module.exports = __webpack_public_path__ + "img/2.6d53e427.png";